import { css } from 'styled-components'

export const sizes = {
    desktop: 1040,
    tablet: 768,
    phone: 480,
}

// Example
// ${media.desktop`padding: 0 20px;`}
// ${media.tablet`padding: 0 10px;`}
// ${media.phone`padding: 0 5px;`}

// iterate through the sizes and create a media template
export const media = Object.keys(sizes).reduce((accumulator, label) => {
    // use em in breakpoints to work properly cross-browser and support users
    // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
    const emSize = sizes[label] / 16
    accumulator[label] = (...args) => css`
        @media (max-width: ${emSize}em) {
            ${css(...args)};
        }
    `
    return accumulator
}, {})

export const minMedia = Object.keys(sizes).reduce((accumulator, label) => {
    // use em in breakpoints to work properly cross-browser and support users
    // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
    const emSize = sizes[label] / 16
    accumulator[label] = (...args) => css`
        @media (min-width: ${emSize}em) {
            ${css(...args)};
        }
    `
    return accumulator
}, {})



// WEBPACK FOOTER //
// ./src/components/StyledComponents/style-utils.js